import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2070. ダッシュボード（フェーズ毎件数と金額）
 * [GET] /workspaces/:identifier/dashboard/phase_count_and_amounts
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
  business_partner_ids: number[];
  agency_ids: number[];
};

type DashboardPhaseCountAndAmount = {
  name: string;
  count: number;
  amount: number;
};

const dashboardPhaseCountAndAmounts = (props: Props): Promise<DashboardPhaseCountAndAmount[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/phase_count_and_amounts`, { params: props });
};

export const useDashboardPhaseCountAndAmounts = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'phase_count_and_amount', { ...props }],
    queryFn: () => dashboardPhaseCountAndAmounts(props),
    staleTime: 1000 * 60 * 30,
  });
};
